
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch, RootState } from "../../store";

import { endLoadingCurso, setBloques, setCursos, setModulos, setSecciones, setEjercicios, setAyudantias, setNoticias, CursoState } from "./cursoSlice";

export const obtenerCursos = () => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken('curso/obtener');
            const body = await resp.json();

            if (body.ok) {
                const { cursos } = body;

                dispatch(setCursos(cursos));
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const obtenerCurso = (cid: string, tag: string) => {

    console.log(cid, tag)

    return async (dispatch: AppDispatch) => {        

        // try {
        //     const resp = await fetchConToken(`curso/obtener/${cid}/${tag}`);
        //     const body = await resp.json();

        //     if (body.ok) {
        //         const { modulos, bloques, secciones, ayudantias, ejercicios, noticias } = body;

        //         const seccionesMax = secciones.map((item: any) =>  {
        //             return ({...item, estadistica: item.estadistica})
        //         })

        //         dispatch(endLoadingCurso());
        //         dispatch(setModulos(modulos));
        //         dispatch(setBloques(bloques));
        //         dispatch(setSecciones(seccionesMax));
        //         dispatch(setEjercicios(ejercicios));
        //         dispatch(setAyudantias(ayudantias));
        //         dispatch(setNoticias(noticias));
        //         return 
        //     }

        // } catch (error) {
        //     console.log(error)
        // }
    }
}

export const actualizarActivoSeccion = (seccion: any) => {

    return async (dispatch: AppDispatch, getState: RootState) => { 
        
        const { secciones } = getState.curso;

        const seccionesActualizada = secciones.map((item: any) => (
            item.sid === seccion.sid ? 
            { ...item, activo: seccion.activo } : item
        ));

        dispatch(setSecciones(seccionesActualizada))

    }
}

export const actualizarDBSeccion = (dbSeccion: any) => {

    return async (dispatch: AppDispatch, getState: RootState) => { 
        
        const { secciones } = getState.curso;

        const seccionesActualizada = secciones.map((item: any) => (
            item.sid === dbSeccion.sid ? 
            { ...item, 
                ejercicio: {
                    enunciado: item.ejercicio.enunciado,
                    alternativas: item.ejercicio.alternativas, 
                    estado: dbSeccion.estado
                }
            } : item
        ));

        dispatch(setSecciones(seccionesActualizada))

    }
}

export const actualizarEstadisticaSeccion = (estadistica: any) => {

    return async (dispatch: AppDispatch, getState: RootState) => { 
        
        const { secciones } = getState.curso;

        const seccionesActualizada = secciones.map((item: any) => (
            item.sid === estadistica.sid ? 
            { ...item, 
                estadistica : {
                    correctas: estadistica.correctas,
                    incorrectas: estadistica.incorrectas
                }
            } : item
        ));

        dispatch(setSecciones(seccionesActualizada))

    }
}

export const actualizarEjercicio = (eid: String, estado: Boolean) => {

    return async (dispatch: AppDispatch, getState: RootState) => { 
        
        const { ejercicios } = getState.curso;

        const seccionesActualizada = ejercicios.map((item: any) => (
            item.eid === eid ? 
            { ...item, 
                estado: estado
            } : item
        ));

        dispatch(setEjercicios(seccionesActualizada))

    }
}
